import dayjs from 'dayjs';

export const formatDateShort = (date: string) => {
  const dayjsDate = dayjs(date);
  return dayjsDate.format('MMM DD, YYYY');
};

export const formatDate = (date: string) => {
  const dayjsDate = dayjs(date);
  return dayjsDate.format('MMM DD, YYYY - h:mm A');
};
